import React from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { PublicationMobileVersionSelectorProps } from '../../interfaces';
import styles from '../../publicationDetailMobile.module.scss';



const PublicationMobileVersionSelector: React.FC<PublicationMobileVersionSelectorProps> = ({
    publication,
    selectedVersion,
    setSelectedVersion,
    type,
    vehicleTypeSelected,
    brand,
    addPointsInText
}) => {
    if (type === "myPublication" || vehicleTypeSelected !== "new" || !brand) {
        return null;
    }

    return (
        <div className={styles.versionSelector}>
            <h3 className={styles.selectorTitle}>Selecciona la versión</h3>
            <FormControl component="fieldset" fullWidth>
                <RadioGroup
                    name="vehicleVersion"
                    value={selectedVersion}
                    onChange={(e) => setSelectedVersion && setSelectedVersion(e.target.value)}
                >
                    {(publication?.vehicles || []).length > 0 ? (
                        [...publication.vehicles]
                            .sort((a, b) => (a.price || 0) - (b.price || 0))
                            .map((vehicle: any) => (
                                <div
                                    className={`${styles.versionCardContainer} ${selectedVersion === vehicle._id ? styles.selectedVersion : ''}`}
                                    key={vehicle._id}
                                >
                                    <FormControlLabel
                                        value={vehicle._id}
                                        control={<Radio
                                            sx={{
                                                '&': { color: '#6B2FF5' },
                                                '&.Mui-checked': { color: '#6B2FF5' },
                                                '& .MuiSvgIcon-root': { color: '#6B2FF5' }
                                            }}
                                        />}
                                        className={styles.versionRadio}
                                        label={
                                            <div className={styles.versionOption}>
                                                <div className={styles.versionName}>
                                                    {vehicle.version || vehicle.name || `${vehicle.year} ${vehicle.model}`}
                                                </div>
                                                <div className={styles.versionPrice}>
                                                    ${addPointsInText(vehicle.price)}
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>
                            ))
                    ) : (
                        <></>
                    )}
                </RadioGroup>
            </FormControl>
        </div>
    );
};

export default PublicationMobileVersionSelector;
